import { render, staticRenderFns } from "./SmallLegend.vue?vue&type=template&id=cf82b648&scoped=true&"
import script from "./SmallLegend.vue?vue&type=script&lang=js&"
export * from "./SmallLegend.vue?vue&type=script&lang=js&"
import style0 from "./SmallLegend.vue?vue&type=style&index=0&id=cf82b648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf82b648",
  null
  
)

export default component.exports